import { Descriptions } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ISpeakingItem } from '../../../models/speaking.model';
import Radio from '../../Radio';
import Button from '../../Button';
import { useHistory } from 'react-router';
import useNotification from '../../../hooks/useNotification';

interface IProps {
  speakingItem?: ISpeakingItem;
  onSubmit: (req: ISpeakingItem) => void;
}

const SpeakingItemEditor: FC<IProps> = ({ speakingItem, onSubmit }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { infoNotification } = useNotification();

  const [evaluationItemName, setEvaluationItemName] = useState('');
  const [useYn, setUseYn] = useState('Y');
  const [memo, setMemo] = useState('');

  useEffect(() => {
    if (speakingItem) {
      setEvaluationItemName(speakingItem.evaluationItemName);
      setUseYn(speakingItem.useYn);
      setMemo(speakingItem.memo);
    }
  }, [speakingItem]);

  const onSave = () => {
    if (!evaluationItemName) {
      return infoNotification(t('cbt.speakingItem.1'))
    }

    onSubmit({
      evaluationItemName,
      useYn,
      memo,
    });
  }

  return (
    <>
      <div>
        <Descriptions
          bordered
          column={1}
          labelStyle={{ textAlign: 'center' }}
        >
          <Descriptions.Item label={t('cbt.speakingItem.2')}>
            <input
              type="text"
              className="form-control"
              value={evaluationItemName}
              onChange={(e) => setEvaluationItemName(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('cbt.speakingItem.3')}>
            <Radio
              checked={useYn === 'Y'}
              onChange={() => setUseYn('Y')}
              text={t('common.option.yes')}
            />
            <Radio
              className="ml-4"
              checked={useYn === 'N'}
              onChange={() => setUseYn('N')}
              text={t('common.option.no')}
            />          
          </Descriptions.Item>
          <Descriptions.Item label={t('cbt.speakingItem.4')}>
            <input
              type="text"
              className="form-control"
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
            />          
          </Descriptions.Item>
        </Descriptions>
      </div>
      <div className="row mt-4">
        <div className="col-4">
          <Button
            className='btn btn-primary ml-2 btn-w100p'
            onClick={() => history.push('/cbt/speaking-item')}
            text={t('common.button.list')}
          />
        </div>
        <div className="col-4 text-center">
          <Button
            className='btn btn-primary ml-2 btn-w100p'
            onClick={onSave}
            text={t('common.button.save')}
          />
        </div>
        <div className="col-4" />
      </div>
    </>
  );
}

export default SpeakingItemEditor;
